import { IconLayoutHalf } from 'central-icons/IconLayoutHalf';
import { IconLayoutSidebar } from 'central-icons/IconLayoutSidebar';
import classNames from 'classnames';

import { ButtonGroup, IconButton } from '@revelio/ui';

import styles from './ViewModeToggle.module.css';

interface ViewModeToggleProps {
  viewMode: 'list' | 'card';
  onViewModeChange: (mode: 'list' | 'card') => void;
}

export const ViewModeToggle = ({
  viewMode,
  onViewModeChange,
}: ViewModeToggleProps) => {
  return (
    <div className={styles.container}>
      <div
        className={classNames(
          styles.slider,
          viewMode === 'list' ? styles.sliderList : styles.sliderCard
        )}
      />
      <ButtonGroup size="sm" className={styles.buttonGroup}>
        <IconButton
          aria-label="List View"
          icon={<IconLayoutSidebar size={14} />}
          onClick={() => onViewModeChange('list')}
          className={classNames(
            styles.toggleButton,
            viewMode === 'list' && styles.toggleButtonActive
          )}
          data-testid="td-list-view-toggle"
        />
        <IconButton
          aria-label="Card View"
          icon={<IconLayoutHalf size={14} strokeWidth="0px" />}
          onClick={() => onViewModeChange('card')}
          className={classNames(
            styles.toggleButton,
            viewMode === 'card' && styles.toggleButtonActive
          )}
          data-testid="td-card-view-toggle"
        />
      </ButtonGroup>
    </div>
  );
};
